import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { getControlNumber, setControlNumber, getApplicationFlow, tourConfig_driver_flow, tourConfig_carrier_flow } from '../../Utils/Utility';
import NavItem from './NavItem';
import { AppConstatnt } from "../../Utils/AppConstant";
import { injectIntl } from 'react-intl';
import Tour from '../Tour/Tour';
import { isMobile } from 'react-device-detect';
class SideNav extends Component {

    constructor(props) {
        super(props);
        const { formatMessage } = props.intl;
        const paymentsArr1 = [
            {
                path: '/',
                name: this.props.intl.formatMessage({ id: "app.payments" }),
                css: 'fal fa-truck-loading',
                title: this.props.intl.formatMessage({ id: "app.header" }),
                key: 1
            }
        ]

        const supportArray = [
            {
                path: '/liveSupport',
                name: this.props.intl.formatMessage({ id: "app.LIVE_SUPPORT" }),
                css: 'far fa-comment-alt',
                title: this.props.intl.formatMessage({ id: "app.header" }),
                key: 1
            }
        ]

        const insert = (arr, index, ...newItems) => [
            ...arr.slice(0, index),
            ...newItems,
            ...arr.slice(index)
        ]

        const otherPayments = {
            path: '/driverMobile',
            name: this.props.intl.formatMessage({ id: "app.another_driver_payment" }),
            css: 'fal fa-search-dollar',
            title: '',
            key: 2,
            id: 'react_tour_step_8'
        }

        const checkCarrier = getApplicationFlow() === AppConstatnt.flow.CARRIER;

        this.state = {
            activePath: props.location.pathname,
            items: checkCarrier ? insert(paymentsArr1, 1, otherPayments) : paymentsArr1,
            formatMessage: this.props.intl.formatMessage,
            intl: this.props.intl,
            supportArray: supportArray,
            startTour: false,
            tourConfig_carrier_flow: [
                {
                    content: formatMessage({ id: "app.react_tour_step_1" }),
                    key: "app.react_tour_step_1",
                    target: "body",
                    placement: "center",
                },
                {
                    target: '.react_tour_step_2',
                    content: formatMessage({ id: "app.react_tour_step_2" }),
                    key: "app.react_tour_step_2"
                },

                {
                    target: '.react_tour_step_3',
                    content: formatMessage({ id: "app.react_tour_step_3" }),
                    key: "app.react_tour_step_3"
                },

                {
                    target: '.react_tour_step_4',
                    content: formatMessage({ id: "app.react_tour_step_4" }),
                    key: "app.react_tour_step_4"
                },
                {
                    target: '.react_tour_step_5',
                    content: formatMessage({ id: "app.react_tour_step_5" }),
                    key: "app.react_tour_step_5"
                },
                {
                    target: '.react_tour_step_6',
                    content: formatMessage({ id: "app.react_tour_step_6" }),
                    key: "app.react_tour_step_6"
                },
                {
                    target: '.react_tour_step_7',
                    content: formatMessage({ id: "app.react_tour_step_7" }),
                    key: "app.react_tour_step_7"
                },
                {
                    target: '#react_tour_step_8',
                    content: formatMessage({ id: "app.react_tour_step_8" }),
                    key: "app.react_tour_step_8"
                },
                {
                    target: '.react_tour_step_9',
                    content: formatMessage({ id: "app.react_tour_step_9" }),
                    key: "app.react_tour_step_9"
                },
                {
                    target: '.react_tour_step_10',
                    content: formatMessage({ id: "app.react_tour_step_10" }),
                    key: "app.react_tour_step_10"
                },
                {
                    target: '.react_tour_step_11',
                    content: formatMessage({ id: "app.react_tour_step_11" }),
                    key: "app.react_tour_step_11"
                },
                {
                    target: '.react_tour_step_12',
                    content: formatMessage({ id: "app.react_tour_step_12" }),
                    key: "app.react_tour_step_12"
                },

            ],
            tourConfig_driver_flow: [
                {
                    content: formatMessage({ id: "app.react_tour_step_1" }),
                    key: "app.react_tour_step_1",
                    target: "body",
                    placement: "center"
                },
                {
                    target: '.react_tour_step_2',
                    content: formatMessage({ id: "app.react_tour_step_2" }),
                    key: "app.react_tour_step_2"
                },

                {
                    target: '.react_tour_step_3',
                    content: formatMessage({ id: "app.react_tour_step_3" }),
                    key: "app.react_tour_step_3"
                },

                {
                    target: '.react_tour_step_4',
                    content: formatMessage({ id: "app.react_tour_step_4" }),
                    key: "app.react_tour_step_4"
                },
                {
                    target: '.react_tour_step_5',
                    content: formatMessage({ id: "app.react_tour_step_5" }),
                    key: "app.react_tour_step_5"
                },
                {
                    target: '.react_tour_step_6',
                    content: formatMessage({ id: "app.react_tour_step_6" }),
                    key: "app.react_tour_step_6"
                },
                {
                    target: '.react_tour_step_7',
                    content: formatMessage({ id: "app.react_tour_step_7" }),
                    key: "app.react_tour_step_7"
                },
                {
                    target: '.react_tour_step_9',
                    content: formatMessage({ id: "app.react_tour_step_9" }),
                    key: "app.react_tour_step_9"
                },
                {
                    target: '.react_tour_step_10',
                    content: formatMessage({ id: "app.react_tour_step_10" }),
                    key: "app.react_tour_step_10"
                },
                {
                    target: '.react_tour_step_11',
                    content: formatMessage({ id: "app.react_tour_step_11" }),
                    key: "app.react_tour_step_11"
                },
                {
                    target: '.react_tour_step_12',
                    content: formatMessage({ id: "app.react_tour_step_12" }),
                    key: "app.react_tour_step_12"
                },

            ],
            tour_sideBarHeading: this.props.intl.formatMessage({ id: "app.react_tour_sidebar_heading" }),
            tour_sideBarBtnText: this.props.intl.formatMessage({ id: "app.react_tour_sidebar_btnText" })

        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.intl.locale !== prevState.intl.locale) {
            return ({
                items: prevState.items.map(obj => {

                    if (obj.key === 2)
                        Object.assign(obj, { name: nextProps.intl.formatMessage({ id: "app.another_driver_payment" }) });
                    else
                        Object.assign(obj, { name: nextProps.intl.formatMessage({ id: "app.payments" }), title: nextProps.intl.formatMessage({ id: "app.header" }) });
                    return obj;
                }),
                tour_sideBarHeading: nextProps.intl.formatMessage({ id: "app.react_tour_sidebar_heading" }),
                tour_sideBarBtnText: nextProps.intl.formatMessage({ id: "app.react_tour_sidebar_btnText" }),
                tourConfig_carrier_flow: prevState.tourConfig_carrier_flow.map(obj => {
                    return Object.assign(obj, { content: nextProps.intl.formatMessage({ id: obj.key }) })
                }),
                tourConfig_driver_flow: prevState.tourConfig_driver_flow.map(obj => {
                    return Object.assign(obj, { content: nextProps.intl.formatMessage({ id: obj.key }) })
                }),
                intl: nextProps.intl
            })
        }
        if (prevState.startTour && nextProps.location.pathname !== "/") {
            return ({ startTour: false })
        }
        return null
    }


    onItemClick = (path) => {
        this.setState({ activePath: path });
        if (path === '/') {
            setControlNumber('');
        }

    }

    handleClick = (e) => {
        const controle_number = getControlNumber();
        const name = this.props?.userData.given_name + " " + this.props?.userData.family_name
        const phone = getApplicationFlow() === 'Driver' ? this.props?.userData?.phone_number : this.props?.userData['custom:carrierPhone'];
        const subject = controle_number ? controle_number : `${name} || ${phone}`

        window.open(`mailto:support@freightsmith.net?subject=${subject}`)
    }

    tourStartHandler = () => {

        if (this.props.location.pathname !== "/") {
            this.props.history.push('/');
        }
        this.setState({ startTour: true })
    }

    resetTourHandler = () => {
        this.setState({ startTour: false })
    }


    render() {
        const { items, activePath, supportArray } = this.state;
        return (


            <div className="left-side-menu left-side-menu-detached">
                <div className="leftbar-user"></div>

                <ul className="metismenu side-nav">
                    {
                        items.map((item) => {
                            return (
                                <NavItem
                                    path={item.path}
                                    name={item.name}
                                    css={item.css}
                                    title={item.title}
                                    onItemClick={this.onItemClick}
                                    active={item.path === activePath}
                                    key={item.key}
                                    closeHandler={this.props.handleClose}
                                    id={item.id || ''}

                                />
                            );
                        })
                    }
                </ul>


                <div className="metismenu side-nav">

                    <span className="side-nav-title">{this.state.intl.formatMessage({ id: "app.support" })}</span>
                    {
                        supportArray.map((item) => {
                            return (
                                <NavItem
                                    path={item.path}
                                    name={item.name}
                                    css={item.css}
                                    title={""}
                                    onItemClick={this.onItemClick}
                                    active={item.path === activePath}
                                    key={item.key}
                                    closeHandler={this.props.handleClose}
                                    id={item.id || ''}

                                />
                            );
                        })
                    }
                    <div className='side-nav-link react_tour_step_9'>
                        <p className='h6'>
                            <i className="fal fa-phone-alt fa-fw"></i>
                            (855) 752-2878
                        </p>
                        <p className='h6'>
                            <i className="fal fa-envelope fa-fw"></i>
                            <input className="btn-bg-none" type="button" onClick={this.handleClick} value="support@freightsmith"></input>
                        </p>

                    </div>
                </div>
                {/* {!isMobile &&  <div className="metismenu side-nav">
                <span className="side-nav-title">{this.state.intl.formatMessage({ id: "app.react_tour_sidebar_heading" })}</span>
                <div className='side-nav-link'>
                    <div>
                    <i class="fal fa-flag-checkered"></i>
                           <button className='btn btn-chartreuse justify-content-center min-width mr-2' onClick={this.tourStartHandler}>{this.state.intl.formatMessage({ id: "app.react_tour_sidebar_btnText" })}</button>
                           </div>
                </div>
                </div>} */}



                <div className="copy_right">FreightSmith TM &copy; 2021</div>
                {/* <Tour tourConfig={getApplicationFlow() === 'Carrier' ? this.state.tourConfig_carrier_flow : this.state.tourConfig_driver_flow } startTour={this.state.startTour}  resetTourHandler={this.resetTourHandler}/> */}
            </div>

        )
    }
}
const RouterSideNav = withRouter(injectIntl(SideNav));


export default class Sidebar extends React.Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <RouterSideNav {...this.props}></RouterSideNav>
        );
    }
}